import { Button } from '../../../../components/v3/Button/Button';
import React, {
  useEffect,
  useState
} from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useNavigate, useLocation } from 'react-router-dom';
import { useRecoilValue, useSetRecoilState, useRecoilState } from 'recoil';
import { TransactionDetailModal } from '../../../../components/TransactionDetailModal/transactionDetailModal';
import { StaticRoutes } from '../../../../Router';
import { ArrowDown } from '../../../../assets';
import { Accordion, TableComponent, CircularProgressBar, Footer, RangeSlider } from '../../../../components';
import { Table } from '../../../../components/table/table';
import { useModal } from '../../../../components/modalController/useModal';
import { StatusChip } from '../../../../components/statusChip/statusChip';
import { AccordionStyle, FaqRcf, Colors, Fonts } from '../../../../constants';
import { getTransactionDetails } from '../../../../api/vodaLend';
import { useLoader } from '../../../../components/Loader/useLoader';
import { formatCurrency } from '../../../../helpers';
import {
  applicationStatuses,
  creditFacilityDetailsQuery,
  useShowToast,
  useIsMobile,
  pageTitleSubmit,
  withdrawalAmountState,
  rcfTransactionsQuery,
  isToastVisible
} from '../../../../recoil';
import { useTealium } from '../../../../tealium/useTealium';
import styles from './RCFAccount.module.css';
import {
  FaqComponent
} from '../../../../components';
import { IncreaseLimitModal } from './increaseLimitModal/increaseLimitModal';

const MIN_WITHDRAWAL_AMT = 1000;
const PERCENT_MULT = 100;
const DISABLED_OPACITY = 0.6;
const style = {
  reviewBtnWeb: {
    border: 'none',
    color: '#A8ACB8',
    justifyContent: 'left'
  },
  reviewBtnMobile: {
    border: 'none',
    color: '#A8ACB8',
    justifyContent: 'center'
  },
  faqContainerOuter: {
    display: 'flex',
    justifyContent: 'center',
    border: `1px solid ${Colors.GreyScale5}`,
    borderRadius: 8,
    paddingTop: 15,
    paddingBottom: 20,
    //width: '95%',
    marginBottom: 80
  },
  faqContainerInner: {
    width: '95%',
    height: '100%'
  },
  faqHeading: {
    fontFamily: Fonts.RobotoMedium,
    fontSize: 18,
    lineHeight: '24px',
    display: 'flex',
    marginBottom: 10,
    color: Colors.GreyScale10_1
  },
  accordionStyle: {
    borderRadius: 5,
    border: `1px solid ${Colors.GreyScale5}`,
    paddingTop: 20,
    paddingBottom: 20,
    marginBottom: 30
  },
  accordionTitle: {
    ...AccordionStyle.accordionTitle,
    color: Colors.GreyScale10_1,
    fontSize: 24
  },
  tableContainer: {
    width: '90%',
    display: 'flex'
  }
};

const LimitIncreaseListItem = ({ isEligible, isLinkDisabled, isToastActive, onApplyClick, onInProgressClick }) => {
  if (isEligible) {
    return (
      <li>
        <span
          onClick={!isLinkDisabled ? onApplyClick : undefined}
          className={isLinkDisabled ? styles.urlDisabled : styles.url}
          style={{ pointerEvents: isLinkDisabled ? 'none' : 'auto', opacity: isLinkDisabled ? DISABLED_OPACITY : 1 }}
        >Apply for a limit increase</span>
      </li>
    );
  }
  return (
    <li>
      <span
        onClick={!isToastActive ? onInProgressClick : undefined}
        className={styles.urlDisabled}
        style={{ pointerEvents: isToastActive ? 'none' : 'auto', opacity: isToastActive ? DISABLED_OPACITY : 1 }}
      >Increase Cash Flow Facility limit [in progress]</span>
    </li>
  );
};

LimitIncreaseListItem.propTypes = {
  isEligible: PropTypes.bool,
  isLinkDisabled: PropTypes.bool,
  isToastActive: PropTypes.bool,
  onApplyClick: PropTypes.func,
  onInProgressClick: PropTypes.func
};

export const RCFAccount = ({ applicationId, businessId }) => {

  const [openSection, setOpenSection] = useState('summary');
  const [isOpenTransactionDetailModal, setIsOpenTransactionDetailModal] = useState(false);
  const [sliderWithdrawalAmount, setSliderWithdrawalAmount] = useState(0);
  const [isLimitLinkDisabled, setIsLimitLinkDisabled] = useState(false);
  const [openModal, closeModal] = useModal();
  const [, setPageTitle] = useRecoilState(pageTitleSubmit);
  const [transactionHistoryDetails, setTransactionHistoryDetails] = useState(null);
  const [transactionId, setTransactionId] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  //   const transactions = useRecoilValue(rcfTransactionsQuery);
  const creditFacilityDetails = useRecoilValue(creditFacilityDetailsQuery({ businessId, applicationId }));
  const [_amtToWithdraw, setAmtToWithdraw] = useState(0);

  const formattedWithdrawAmount = formatCurrency(sliderWithdrawalAmount);
  const formattedAmountAvailable = formatCurrency(creditFacilityDetails.amountAvailable);
  const formattedAmountOwed = formatCurrency(creditFacilityDetails.amountOwed);
  const formattedCapitalOwed = formatCurrency(creditFacilityDetails.capitalOwed);
  const formattedAmountLimit = formatCurrency(creditFacilityDetails.amountLimit);
  const appStates = useRecoilValue(applicationStatuses);
  const setAmtToWithdraw3 = useSetRecoilState(withdrawalAmountState);
  // const [openLoader, closeLoader] = useLoader();
  const showToast = useShowToast();
  const { track, events } = useTealium();
  const isMobile = useRecoilValue(useIsMobile);
  const transactionHistory = useRecoilValue(rcfTransactionsQuery({ businessId }));
  const accordionStyleFn = (data) => ({ ...(isMobile ? { ...data, borderRadius: 20 } : data) });
  const [openLoader, closeLoader] = useLoader();
  const isToastActive = useRecoilValue(isToastVisible);

  useEffect(() => {
    track(events.creditFacility.pageView());
  }, []);

  useEffect(() => {
    // Reset the slider value on URL change
    setSliderWithdrawalAmount(0);
    setAmtToWithdraw(0); // Resetting the recoil local state too (if needed)
    setAmtToWithdraw3(0); // Resetting global recoil state if needed
  }, [location.pathname]);

  const isValidExposure = (selectedAmt, owedAmt) => {
    const totalAmt = owedAmt + selectedAmt;
    return totalAmt < MIN_WITHDRAWAL_AMT;
  };

  const isBtnEnabled = sliderWithdrawalAmount > 0;

  const TransactionHeader = {
    date: 'Date',
    description: 'Description',
    reference: 'Reference',
    withdrawalAmount: 'withdrawal Amount',
    capital: 'Capital'
  };

  const rcfSummaryDetails = [
    { label: 'Cash Flow Facility Limit:', value: formattedAmountLimit },
    { label: 'Capital Owed:', value: formattedCapitalOwed },
    { label: 'Total Owed:', value: formattedAmountOwed },
    { label: 'Total Available:', value: formattedAmountAvailable }
  ];

  useEffect(() => {
    if (!appStates?.isCreditFacilityCreated) {
      navigate(StaticRoutes.applications);
    }
  }, [navigate, appStates]);

  const handleClickOnCrossIcon = () => {
    track(events.creditFacility.closeTransactionViewMoreModal());
    setTransactionHistoryDetails(null);
    setIsOpenTransactionDetailModal(false);
  };

  const transactionDetailModalBody = (transactionHistoryDetails) => {

    if (transactionHistoryDetails?.records?.length === 0) {
      return 'No transaction detail found';
    }
    return (
      <>
        <Table
          data={
            transactionHistoryDetails?.records?.map((d) => ({
              ...d,
              paymentDate: moment(d.paymentDate).format('DD-MMM-YY'),
              capitalAmount: formatCurrency(d.capitalAmount),
              costAmount: formatCurrency(d.costAmount),
              paymentAmount: formatCurrency(d.paymentAmount),
              paidAmount: formatCurrency(d.paidAmount),
              arrears: formatCurrency(d.arrears)
            }))
          }
          heading={{
            paymentDate: 'Date',
            capitalAmount: 'Capital',
            costAmount: 'Cost',
            paymentAmount: 'Amount',
            paidAmount: 'Paid Amount',
            arrears: 'Arrears',
            status: 'Status'
          }}
          footer={{
            costAmount: formatCurrency(transactionHistoryDetails.total.costAmount),
            capitalAmount: formatCurrency(transactionHistoryDetails.total.capitalAmount),
            paymentAmount: formatCurrency(transactionHistoryDetails.total.paymentAmount),
            paidAmount: formatCurrency(transactionHistoryDetails.total.paidAmount),
            arrears: formatCurrency(transactionHistoryDetails.total.arrears),
            paymentDate: 'TOTAL'
          }}
        />
      </>
    );
  };

  const handleTransactionClick = async (id) => {
    track(events.creditFacility.transactionsViewMore());
    try {
      openLoader();
      const transactionHistoryDetails = await getTransactionDetails(businessId, id);
      setTransactionHistoryDetails(transactionHistoryDetails);
      setTransactionId(id);
      setIsOpenTransactionDetailModal(true);
      track(events.creditFacility.transactionPageView());
    } catch {
      track(events.error('event', location.pathname, 'There was an error fetching your transaction details.', 'Cash Flow Facility'));
      openModal({
        title: 'Error',
        children: <div>There was an error fetching your transaction details.</div>,
        type: 'error',
        actions: [
          <Button
            style={{ display: 'flex', maxWidth: 230, width: '100%', justifyContent: 'center' }}
            key="ViewTransactionDetailsFailed"
            onClick={() => closeModal()}>
            Close
          </Button>
        ]
      });
    } finally {
      closeLoader();
    }
  };

  const handleIncreaseLimitClick = () => {
    if (isLimitLinkDisabled) { return; }
    setIsLimitLinkDisabled(true);
    track(events.creditFacility.increaseCapitalLimit());

    openModal({
      title: 'Apply for a limit increase',
      noCloseIcon: isMobile ? true : false,
      children:
        <IncreaseLimitModal
          capitalFacilityId={creditFacilityDetails.id}
          currentLimit={creditFacilityDetails.amountLimit}
          onView={() => track(events.limitIncrease.pageView())}
          onSuccess={() => track(events.limitIncreaseSuccess.pageView())}
          businessId={businessId}
          applicationId={applicationId} />
    });
  };

  const handleInprogressIncreaseLimitClick = () => {
    track(events.creditFacility.inprogressIncreaseCapitalLimit());
    if (!creditFacilityDetails.limitIncreaseEligibility) {
      showToast('You have already requested a limit increase. Please try again after the existing request has been processed.', 'info');
      return;
    }
  };

  const handleRangeSliderChange = (value) => {
    const val = +value;
    if (val !== sliderWithdrawalAmount) {
      setSliderWithdrawalAmount(val);
    }
  };

  const navigateToWithdrawal = () => {
    track(events.creditFacility.viewWithdrawal());
    if (isValidExposure(sliderWithdrawalAmount, creditFacilityDetails.amountOwed)) {
      openModal({
        children: <div>Exposure upon withdrawal must be higher or equal to R10k. Please select higher amount such that the minimum exposure is R10k or more.</div>,
        actions: [<Button key="close" onClick={closeModal}>Close</Button>]
      });
    }
    else {
      setAmtToWithdraw(+sliderWithdrawalAmount);
      setAmtToWithdraw3(+sliderWithdrawalAmount);
      setPageTitle({ pageTitle: '' });
      navigate(`/accounts/${businessId}/withdrawal/${applicationId}`);

    }
  };

  return (
    <main className={styles.main}>
      <div>
        <div className={styles.header}>
          <div className={styles.title}>Cash Flow Facility</div>
          <StatusChip status={creditFacilityDetails.status} />
        </div>
        <Accordion
          containerStyle={isMobile ? { borderRadius: 19 } : { borderRadius: 5 }}
          title="Summary"
          isOpen={openSection === 'summary'}
          headerChildren={
            <>
              <div style={AccordionStyle.accordionHeaderLeft}>
                <div style={isMobile ? { ...AccordionStyle.accordionTitle, fontSize: '1.125rem' } : AccordionStyle.accordionTitle}>
                  {'Summary'}
                </div>
              </div>

              <div>
                <img
                  style={{ ...AccordionStyle.ArrowImg, rotate: openSection === 'summary' ? '180deg' : '' }}
                  src={ArrowDown}
                  alt="DropdownOpen"
                  role="presentation"
                  onClick={() => { track(events.creditFacility.toggleAccordian('summary', openSection === 'summary' ? 'collapse' : 'expand')); setOpenSection(openSection === 'summary' ? '' : 'summary'); }}
                  onKeyDown={() => { track(events.creditFacility.toggleAccordian('summary', openSection === 'summary' ? 'collapse' : 'expand')); setOpenSection(openSection === 'summary' ? '' : 'summary'); }}
                />
              </div>
            </>
          }
        >

          <div className={styles.summaryContainer}>
            <ul className={styles.summaryList}>
              <li>You can currently withdraw up to <span className={styles.boldText}>{formattedAmountAvailable}</span></li>
              <li>Your repayment schedule will be adjusted.</li>
              <LimitIncreaseListItem
                isEligible={creditFacilityDetails.limitIncreaseEligibility}
                isLinkDisabled={isLimitLinkDisabled}
                isToastActive={isToastActive}
                onApplyClick={handleIncreaseLimitClick}
                onInProgressClick={handleInprogressIncreaseLimitClick}
              />
            </ul>

            <div className={styles.rangeSlider}>
              <div className={styles.sliderHeader}>Withdrawal amount :  <span
                className={styles.rangeSliderAmount}>{formattedWithdrawAmount}</span></div>
              <RangeSlider
                onChange={handleRangeSliderChange}
                max={creditFacilityDetails.amountAvailable}
                value={+sliderWithdrawalAmount}
                min={0}
                step={1000}
                displayMiddleSliderValue={false}
              />
            </div>

            <div className={styles.summaryDetails}>
              <div className={styles.graph}>
                <CircularProgressBar
                  percentage={(creditFacilityDetails.amountOwed / creditFacilityDetails.amountLimit) * PERCENT_MULT}
                  heading={formattedAmountOwed}
                  subHeading={'Total Owed'}
                  isPercLineRed={false}
                />

                <div className={styles.graphData}>
                  <div className={styles.summaryProgressBarInfo}>
                    <div className={styles.progressIndicator}>
                      <div className={styles.blueEllipse} />
                      <div className={styles.progressLabel}>
                        Total Available
                        <div
                          className={styles.progressLabelAmt}>{formattedAmountAvailable}</div>
                      </div>
                    </div>
                    <div className={styles.progressIndicator}>
                      <div className={styles.redEllipse} />
                      <div className={styles.progressLabel}>
                        Total Owed
                        <div
                          className={styles.progressLabelAmt}>{formattedAmountOwed}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.data}>
                {rcfSummaryDetails.map((d, i) => (
                  <div key={i} className={styles.row}>
                    <div>{d.label}</div>
                    <div><span className={styles.boldText}>{d.value}</span></div>
                  </div>
                ))}
                <Footer
                  rightTitle={'Withdraw Now'}
                  rightCallback={isBtnEnabled ? navigateToWithdrawal : null}
                  containerStyle={isMobile ? style.reviewBtnMobile : style.reviewBtnWeb}
                />
              </div>

            </div>
          </div>
        </Accordion>
        <Accordion
          isOpen={openSection === 'transactionHistory'}
          containerStyle={isMobile ? { borderRadius: 19 } : { borderRadius: 8 }}
          headerChildren={
            <>
              <div style={AccordionStyle.accordionHeaderLeft}>
                <div style={isMobile ? { ...AccordionStyle.accordionTitle, fontSize: '1.125rem' } : AccordionStyle.accordionTitle}>Transaction history</div>
              </div>
              <img
                style={{ ...AccordionStyle.ArrowImg, rotate: openSection === 'transactionHistory' ? '180deg' : '' }}
                src={ArrowDown}
                alt='DropdownOpen'
                role='presentation'
                onClick={() => { track(events.creditFacility.toggleAccordian('transactionHistory', openSection === 'transactionHistory' ? 'collapse' : 'expand')); setOpenSection(openSection === 'transactionHistory' ? '' : 'transactionHistory'); }}
              />
            </>
          }
        >
          <div className={styles.accordion}>

            {Array.isArray(transactionHistory) && (
              <TableComponent
                data={transactionHistory.map(d => ({
                  ...d,
                  capital: formatCurrency(d.capital),
                  withdrawalAmount: formatCurrency(d.withdrawalAmount)
                }))}
                heading={TransactionHeader}
                handleTransactionClick={handleTransactionClick}
              />
            )}
          </div>
        </Accordion>
      </div>

      {isOpenTransactionDetailModal &&
        <TransactionDetailModal
          tittle={`Transaction history: Advance ${transactionId}`}
          body={transactionDetailModalBody(transactionHistoryDetails)}
          onButtonClick={() => handleClickOnCrossIcon}
        />
      }

      <div style={accordionStyleFn(style.faqContainerOuter)}>
        <div style={style.faqContainerInner}>
          <div style={style.faqHeading}>
            FAQ&apos;s
          </div>
          {FaqRcf.map((item) => {
            const key = `faq ${item.title?.replace('?', '')}`;
            return (<FaqComponent
              key={key}
              title={item.title}
              content={item.content}
              changeVisibility={() => { track(events.creditFacility.toggleAccordian(key, openSection === key ? 'collapse' : 'expand')); setOpenSection(openSection === key ? '' : key); }}
              isOpen={openSection === key}
            />);
          })}
        </div>
      </div>
    </main>
  );
};

RCFAccount.propTypes = {
  applicationId: PropTypes.string.isRequired,
  businessId: PropTypes.string.isRequired
};